import React from 'react';

import { Button, Header } from 'semantic-ui-react';

import { useFaqsPageTabContext } from '../../context';

const propTypes = {};
const defaultProps = {};

export default function FaqsPageEmpty() {
  const { onCreateFaqsPage, creating } = useFaqsPageTabContext();

  return (
    <div className="empty-state">
      <Header as="h3">No FAQs page found</Header>
      <p>Create an FAQs page to display your questions and answers on your website.</p>
      <Button
        className="secondary-navy"
        content="Create FAQs Page"
        onClick={onCreateFaqsPage}
        disabled={creating}
        loading={creating}
      />
    </div>
  );
}

FaqsPageEmpty.propTypes = propTypes;
FaqsPageEmpty.defaultProps = defaultProps;
